export default __webpack_public_path__ + "static/media/go-button.5fd4228a.svg";